import React from "react";

import AppUpdates from "@/screens/Updates/AppUpdates";

export default function Screen(): React.JSX.Element {
  return <AppUpdates />;
}
